(function () {
	angular.module('trackeye')
	.filter('currencyCodeToSymbol', ['$filter', function($filter) {
		var codes = {
			DKK: ['kr. ','before'],
			EUR: [' &euro;','after'],
			USD: ['$','before'],
			GBP: ['&pound;','before'],
			SEK: [' kr', 'after'],
			NOK: ['kr ', 'before']
		}

		return function(input, code, fraction) {
			if (isNaN(input))
				return "";

			if (!code)
				return input;

			if (fraction) {
				if (typeof input !== 'number')
					input = parseFloat(input);
					
				input = $filter('number')(input, fraction);
			}

			var symbol = codes[code.toUpperCase()];
			if (!symbol)
				return input+' '+code.toUpperCase();

			return symbol[1] === 'before' ? symbol[0]+input : input+symbol[0]; 
		}
	}]);
})();